const DEPLOYMENT_LOAD_ERROR_PATTERNS = [
  'failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'importing a module script failed',
  'failed to load module script',
  'loading chunk',
  'loading css chunk',
  'unable to preload css',
]

declare global {
  interface Window {
    __DUO_RELOAD_FOR_DEPLOYMENT__?: () => boolean
  }
}

export function isDeploymentLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error || '')
  const normalizedMessage = message.toLowerCase()
  return DEPLOYMENT_LOAD_ERROR_PATTERNS.some((pattern) => normalizedMessage.includes(pattern))
}

export function recoverFromDeploymentError(error: unknown): boolean {
  if (!isDeploymentLoadError(error)) return false

  if (window.__DUO_RELOAD_FOR_DEPLOYMENT__) {
    window.__DUO_RELOAD_FOR_DEPLOYMENT__()
  } else {
    window.location.reload()
  }
  return true
}
